type PlainObject = Record<string, any>

export function range(length: number) {
  return Array.from({ length }, (_, key) => key)
}

function isPlainObject(value: any): value is PlainObject {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function mergeDeepRightArraySafe<T, U>(left: T, right: U): T & U {
  // 1. Arrays always replaced
  if (Array.isArray(left) && Array.isArray(right)) {
    return right as any
  }

  // 2. One side array → replace
  if (Array.isArray(left) || Array.isArray(right)) {
    return right as any
  }

  // 3. Deep merge plain objects
  if (isPlainObject(left) && isPlainObject(right)) {
    const result: PlainObject = { ...left }

    for (const key of Object.keys(right)) {
      const lVal = (left as PlainObject)[key]
      const rVal = (right as PlainObject)[key]

      result[key] = mergeDeepRightArraySafe(lVal, rVal)
    }

    return result as T & U
  }

  // 4. Primitives → replace with right
  return right as any
}
